import { CEDE_LANGUAGE_LABELS } from "./constants";

export const getLanguageLabel = (languageValue: string): string => {
  return CEDE_LANGUAGE_LABELS[languageValue] || "";
};
